(()=>{'use strict';
const one=(s,c=document)=>c.querySelector(s), all=(s,c=document)=>Array.from(c.querySelectorAll(s));
const reduced=()=>window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let observer=null;
if('IntersectionObserver' in window&&!reduced()){
  observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting){entry.target.classList.add('vx-arrive');observer.unobserve(entry.target)}
  }),{rootMargin:'0px 0px -20px 0px',threshold:0.01});
}
function init(scope=document){
  // Animate only small content blocks; never hide the section, product cards, or prices.
  all('.vx-gallery__head,.vx-gallery__card,.vx-hero__inner',scope).forEach(el=>{
    if(el.dataset.vxObserved)return;
    el.dataset.vxObserved='1';
    el.classList.add('vx-reveal');
    if(observer)observer.observe(el);else el.classList.add('vx-arrive');
  });
  all('[data-vx-gallery]',scope).forEach(root=>{
    if(root.dataset.vxReady)return;root.dataset.vxReady='1';
    const track=one('[data-vx-track]',root),fill=one('[data-vx-fill]',root);if(!track)return;
    function update(){let total=track.scrollWidth-track.clientWidth;let fraction=total>0?track.scrollLeft/total:0;let base=track.scrollWidth>0?track.clientWidth/track.scrollWidth:1;
      if(fill)fill.style.width=(Math.min(100,Math.max(5,100*(base+fraction*(1-base)))))+'%';}
    one('[data-vx-prev]',root)?.addEventListener('click',()=>track.scrollBy({left:-track.clientWidth*.85,behavior:reduced()?'instant':'smooth'}));
    one('[data-vx-next]',root)?.addEventListener('click',()=>track.scrollBy({left:track.clientWidth*.85,behavior:reduced()?'instant':'smooth'}));
    track.addEventListener('scroll',update,{passive:true});window.addEventListener('resize',update,{passive:true});update();
  });
}
function ready(){try{init();
  const progress=document.createElement('div');progress.className='vx-progress';progress.setAttribute('aria-hidden','true');document.body.appendChild(progress);
  const top=document.createElement('button');top.className='vx-to-top';top.type='button';top.setAttribute('aria-label','Back to top');top.textContent='↑';document.body.appendChild(top);
  top.addEventListener('click',()=>window.scrollTo({top:0,behavior:reduced()?'instant':'smooth'}));
  let queued=false;
  function update(){queued=false;const d=document.documentElement;const span=d.scrollHeight-d.clientHeight;const p=span>0?window.scrollY/span:0;
    progress.style.transform='scaleX('+Math.max(0,Math.min(1,p))+')';document.body.classList.toggle('vx-scrolled',window.scrollY>25);
    top.classList.toggle('is-visible',window.scrollY>750);
    const hero=one('.vx-hero__image');if(hero&&!reduced()&&window.innerWidth>749){hero.style.transform='translate3d(0,'+Math.min(90,window.scrollY*.13)+'px,0) scale(1.06)';}
  }
  window.addEventListener('scroll',()=>{if(!queued){requestAnimationFrame(update);queued=true}},{passive:true});update();
}catch(err){console.warn('Voltix motion enhancement disabled',err);}}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
document.addEventListener('shopify:section:load',e=>{try{init(e.target)}catch(err){console.warn(err)}});
})();